export default __webpack_public_path__ + "images/ac1461e0f7bd9c5ab79e6d761509b476.png";